/** Section 4.1. The audit log is append only; there is no update or delete. */

export const ACTIVITY_TYPES = [
  'scan',
  'done',
  'assign',
  'date',
  'urgent',
  'qc',
  'pay',
  'ship',
  'hold',
  'intake',
  'rework',
  'note',
  'admin',
  'print',
  'redo',
  'delete',
  // Signed in, signed out, and a failed sign in with the username tried.
  'auth',
  // A photograph added to a case, or removed from it.
  'photo',
  // One field of a case changed after intake.
  'edit',
  // A grant moved, in the role matrix or for one person.
  'access',
  // A case archived, or taken out of the archive. Section 4 of the request of 24 September 2026.
  'archive',
] as const;

export type ActivityType = (typeof ACTIVITY_TYPES)[number];

export const ACTIVITY_TYPE_LABEL: Record<ActivityType, string> = {
  scan: 'Started work',
  done: 'Completed',
  assign: 'Assigned',
  date: 'Dates changed',
  urgent: 'Marked urgent',
  qc: 'Final Check',
  pay: 'Payment',
  ship: 'Dispatch',
  hold: 'Hold',
  intake: 'Intake',
  rework: 'Flag or rework',
  note: 'Note',
  admin: 'Administration',
  print: 'Printed',
  redo: 'Redo',
  delete: 'Deletion',
  auth: 'Sign in',
  photo: 'Photograph',
  edit: 'Case edited',
  access: 'Access',
  archive: 'Archive',
};

export interface ActivityEntry {
  id: string;
  byUserId: string | null;
  byUserName: string | null;
  action: string;
  target: string;
  type: ActivityType;
  /** The case the row belongs to, when it belongs to one. */
  jobOrderNo: string | null;
  /** The tray, when the action was about one. */
  kitId: string | null;
  createdAt: string; // ISO 8601 UTC
}

export function isActivityType(value: string): value is ActivityType {
  return (ACTIVITY_TYPES as readonly string[]).includes(value);
}
